import React, { useContext, useEffect, useRef } from "react";
import SearchSuggtion from "./SearchSuggtion";
import "../styles/components/SearchSuggestionList.scss";
import SuggestionContext from "../contexts/SuggestionContext";
import { Trans } from "react-i18next";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";

const SuggestionList = (props: any) => {
  const { searchSuggestions, setSearchSuggestion } =
    useContext(SuggestionContext);

  const wrapperRef = useRef(null);
  useEffect(() => {
    const specifiedElement = document.getElementById(
      "suggestList"
    ) as HTMLElement;
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !specifiedElement.contains(event.target)) {
        setSearchSuggestion([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("enter", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div ref={wrapperRef} id="suggestList">
      {searchSuggestions && searchSuggestions.length > 0 ? (
        <div className="searchSuggestions">
          {searchSuggestions.map((patient: any, index: number) => {
            return (
              <div key={`suggestion-${index}`}>
                <SearchSuggtion
                  data={patient.resource}
                  onSuggestion={() => props.onSelect(patient.resource)}
                />
              </div>
            );
          })}
          <div className="viewAll" onClick={() => props.onSelect("view all")}>
            <Trans i18nKey={"view_all"}></Trans>
          </div>
        </div>
      ) : (
        <>
          {!searchSuggestions && (
            <div className="emty-searchSuggestions">
              <div className="no_result">
                <Trans i18nKey={"no_result"}></Trans>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ErrorBoundaryHandler(SuggestionList);
